import addComponent from '@utils/addComponent';
import { showConfirmModal } from '@components/ConfirmModal';
import { $tourData } from '@stores/dataStores';
import SandTableCreateModal from '../SandTableCreateModal';
import { MAX_SAND_TABLES } from '../constants';

async function addNewSandTable() {
  const list = $tourData.getState().sandBox ?? [];
  if (list.length >= MAX_SAND_TABLES) {
    await showConfirmModal({
      title: '创建失败',
      buttonText: '我知道了',
      content: `每个作品最多支持创建${MAX_SAND_TABLES}个沙盘`,
    });
    return;
  }
  addComponent((remove) => {
    return <SandTableCreateModal onRequestClose={remove} />;
  });
}

export default addNewSandTable;
